export default __webpack_public_path__ + "static/intech_logo-f34f5ec0da674636fccff4b2db27ca0d.png";